var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.signConfiguration.firma
        ? _c(
            "div",
            [
              _vm.signConfiguration.firma.activa !== "Y" &&
              _vm.signConfiguration.firma.activa !== "P"
                ? _c(
                    "div",
                    { staticClass: "d-flex flex-column align-items-center" },
                    [
                      _vm.signConfiguration.estampa
                        ? _c("img", {
                            staticClass: "mb-5",
                            attrs: {
                              src: _vm.signConfiguration.estampa,
                              width: "400px"
                            }
                          })
                        : _vm._e(),
                      _c("br"),
                      _c("p", { staticClass: "message-info mb-4" }, [
                        _vm._v("Firma configurada correctamente")
                      ]),
                      _c("small", [_vm._v("Generando certificado")])
                    ]
                  )
                : _vm._e(),
              _vm.signConfiguration.firma.activa === "Y"
                ? _c(
                    "div",
                    { staticClass: "d-flex flex-column align-items-center" },
                    [
                      _vm.signConfiguration.estampa
                        ? _c("img", {
                            staticClass: "mb-5",
                            attrs: {
                              src: _vm.signConfiguration.estampa,
                              width: "400px"
                            }
                          })
                        : _vm._e(),
                      _c("br"),
                      _c("p", { staticClass: "message-info mb-4" }, [
                        _vm._v("Firma configurada correctamente")
                      ]),
                      _c("small", [
                        _vm._v(
                          "ID Configuración: " +
                            _vm._s(_vm.signConfiguration.firma.signerUsuario)
                        )
                      ]),
                      _c("small", [
                        _vm._v(
                          "Vencimiento: " +
                            _vm._s(
                              _vm._f("dateFormat")(
                                _vm.signConfiguration.firma.vencimiento
                              )
                            )
                        )
                      ]),
                      !_vm.signConfiguration.firma.atendida
                        ? _c("small", [_vm._v("Firma desatendida activada")])
                        : _vm._e(),
                      _c("br"),
                      _vm.signConfiguration.firma.atendida &&
                      _vm.$route.name === "user-profile"
                        ? _c(
                            "div",
                            [
                              _c("br"),
                              _c(
                                "b-button",
                                {
                                  attrs: { variant: "primary" },
                                  on: { click: _vm.openAttendedModal }
                                },
                                [_vm._v(" Activar firma desatendida ")]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.$route.name === "user-profile"
                        ? _c(
                            "div",
                            { staticClass: "w-100 mt-4" },
                            [
                              _c("ConfigureSignApiStamp", {
                                attrs: {
                                  prefix: "asignapi",
                                  user: _vm.user,
                                  initialConfig: _vm.stampConfig
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                : _vm.signConfiguration.firma.activa === "P" &&
                  _vm.$route.name === "users-management"
                ? _c("div", [
                    _c("h4", [
                      _vm._v(
                        " Firma pendiente de activación, el usuario debe ingresar a su perfil para completar el proceso de registro y enrolamiento "
                      )
                    ])
                  ])
                : _vm.signConfiguration.firma.activa === "P" &&
                  _vm.$route.name === "user-profile"
                ? _c("CompleteActivateEnrollment", {
                    attrs: {
                      signConfiguration: _vm.signConfiguration,
                      user: _vm.user
                    },
                    on: {
                      activate: function($event) {
                        return _vm.$emit("activate")
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _c(
            "div",
            [
              _vm.$route.name === "user-profile"
                ? _c("div", [
                    _c("p", { staticClass: "message-info" }, [
                      _vm._v(
                        " Sin firma configurada dentro de la empresa, contáctese con su administrador "
                      )
                    ])
                  ])
                : _c("ActivateEnrollment", {
                    attrs: {
                      user: _vm.user,
                      signConfiguration: _vm.signConfiguration
                    },
                    on: {
                      signed: function($event) {
                        return _vm.$emit("activate")
                      },
                      activate: function($event) {
                        return _vm.$emit("activate")
                      }
                    }
                  })
            ],
            1
          ),
      _c(
        "b-modal",
        {
          ref: "configModal",
          attrs: {
            "no-close-on-backdrop": "",
            "cancel-title": "Cancelar",
            hideHeaderClose: "",
            centered: "",
            "hide-footer": "",
            size: "lg",
            "ok-disabled": _vm.isLoadingData
          },
          on: { ok: _vm.commitAction, cancel: _vm.cancelProcess }
        },
        [
          _c(
            "b-overlay",
            { attrs: { show: _vm.isLoadingData } },
            [
              _vm.signConfigurationData.urlResponsavilidad
                ? _c(
                    "div",
                    { staticClass: "container-pdf" },
                    _vm._l(_vm.numPages, function(p, index) {
                      return _c("pdf", {
                        key: p + "-" + index,
                        staticClass: "m-auto",
                        attrs: {
                          page: p,
                          src: _vm.signConfigurationData.urlResponsavilidad
                        }
                      })
                    }),
                    1
                  )
                : _vm._e(),
              _c("label", [_vm._v("Código OTP")]),
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|digits:6",
                    expression: "'required|digits:6'"
                  }
                ],
                attrs: {
                  id: "otp_input",
                  name: "otp_input",
                  "data-vv-as": "otp",
                  state: !this.errors.has("otp-form.otp_input"),
                  placeholder: "Ingrese los 6 dígitos enviado a su email"
                },
                model: {
                  value: _vm.otp,
                  callback: function($$v) {
                    _vm.otp = $$v
                  },
                  expression: "otp"
                }
              })
            ],
            1
          ),
          _c(
            "b-button",
            {
              staticClass: "mt-3",
              attrs: { block: "" },
              on: { click: _vm.closeAttendedModal }
            },
            [_vm._v("Cancelar")]
          ),
          _c(
            "b-button",
            {
              staticClass: "mt-3",
              attrs: {
                variant: "primary",
                block: "",
                disabled: _vm.isLoadingData
              },
              on: { click: _vm.commitAction }
            },
            [_vm._v("Confirmar")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }